import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Register regular controllers
import NotificationsController from "./notifications_controller"
import FlashBroadcastController from "./flash_broadcast_controller"
import ReactComponentController from "../react_component_controller"
import ValuationFormController from "./valuation_form_controller"
import ModalFormController from "./modal_form_controller"
import InlineTenantController from "./inline_tenant_controller"
import DatepickerController from "./datepicker_controller"
import BulkActionsController from "./bulk_actions_controller"
import LeaseBreaksModalController from "./lease_breaks_modal_controller"
import SimpleSwitchController from "./simple_switch_controller"
import TenantsPasteController from "./tenants_paste_controller"
import InlineLeaseBreakController from "./inline_lease_break_controller"
import ReportExportController from "./report_export_controller"
import AuditRestoreController from "./audit_restore_controller"
import TenantBatchController from "./tenant_batch_controller"
import AuditPendingPollController from "./audit_pending_poll_controller"
import AuditHighlightController from "./audit_highlight_controller"
import AuditExportController from "./audit_export_controller"
import AuditFilterController from "./audit_filter_controller"
import PushAssumptionsController from "./push_assumptions_controller"
import PasswordPolicyController from "./password_policy_controller"
import RoundingPolicyController from "./rounding_policy_controller"
import IdleTimeoutController from "../../../shared/idle_timeout_controller"

application.register("notifications", NotificationsController)
application.register("flash-broadcast", FlashBroadcastController)
application.register("idle-timeout", IdleTimeoutController)
application.register("react-component", ReactComponentController)
application.register("valuation-form", ValuationFormController)
application.register("modal-form", ModalFormController)
application.register("inline-tenant", InlineTenantController)
application.register("datepicker", DatepickerController)
application.register("bulk-actions", BulkActionsController)
application.register("lease-breaks-modal", LeaseBreaksModalController)
application.register("simple-switch", SimpleSwitchController)
application.register("tenants-paste", TenantsPasteController)
application.register("inline-lease-break", InlineLeaseBreakController)
application.register("report-export", ReportExportController)
application.register("audit-restore", AuditRestoreController)
application.register("tenant-batch", TenantBatchController)
application.register("audit-pending-poll", AuditPendingPollController)
application.register("audit-highlight", AuditHighlightController)
application.register("audit-export", AuditExportController)
application.register("audit-filter", AuditFilterController)
application.register("push-assumptions", PushAssumptionsController)
application.register("password-policy", PasswordPolicyController)
application.register("rounding-policy", RoundingPolicyController)

// Auto-register ViewComponent controllers
const componentControllers = import.meta.glob(
  '../../../../components/**/*_controller.js',
  { eager: true }
)

Object.entries(componentControllers).forEach(([path, module]) => {
  // Extract controller name from path
  // Example: ../../../../components/avatar_stack_component/avatar_stack_component_controller.js
  // -> avatar-stack (without _component suffix)
  const match = path.match(/components\/(.+)\/.+_controller\.js$/)
  if (match) {
    let name = match[1]
    // Remove _component suffix if present
    name = name.replace(/_component$/, '')
    // Convert to kebab-case
    name = name.replace(/_/g, '-')
    application.register(name, module.default)
  }
})
